import { DefaultFocusStatusModel } from "../../../models/DefaultFocusStatusModel";
import { KeyboardNavigation } from "./KeyboardNavigation";

export class SliderNavigation extends KeyboardNavigation {
    findNextFocusableElementWithinSameVariable(
        currentElement: DefaultFocusStatusModel,
        eventKey: string,
    ): DefaultFocusStatusModel | null {
        const index = this.defaultFocusStatus.statuses.indexOf(currentElement);

        if (this.isHybridGrid && (eventKey === "ArrowRight" || eventKey === "ArrowLeft")) {
            return this.findNextFocusableElementWithinSameVariableCommonForHybridGrid(
                currentElement,
                eventKey,
            );
        }

        if (this.isHybridGrid && (eventKey === "ArrowDown" || eventKey === "ArrowUp")) {
            return this.findNextFocusableElementWithinSameVariableCommonForSwitchingRowsForHybridGrid(
                currentElement,
                eventKey,
            );
        }

        if (eventKey === "ArrowDown" || eventKey === "ArrowRight") {
            for (let i = 0; i < this.defaultFocusStatus.statuses.length; i++) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];

                if (
                    elementFocusStatus.variableId === currentElement.variableId &&
                    elementFocusStatus.elementId !== currentElement.elementId &&
                    i > index
                ) {
                    return elementFocusStatus;
                }
            }
        } else if (eventKey === "ArrowUp" || eventKey === "ArrowLeft") {
            for (let i = this.defaultFocusStatus.statuses.length - 1; i >= 0; i--) {
                const elementFocusStatus = this.defaultFocusStatus.statuses[i];
                if (
                    elementFocusStatus.variableId === currentElement.variableId &&
                    elementFocusStatus.elementId !== currentElement.elementId &&
                    i < index
                ) {
                    return elementFocusStatus;
                }
            }
        }

        return null;
    }

    findNextFocusableElementWithinNextVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        return this.findNextFocusableElementWithinNextVariableCommon(currentElement);
    }

    findLastFocusableElementWithinPreviousVariable(
        currentElement: DefaultFocusStatusModel,
    ): DefaultFocusStatusModel | null {
        return this.findLastFocusableElementWithinPreviousVariableCommon(currentElement);
    }
}
